import { Expose, Transform } from "class-transformer";
import { IsBoolean, IsDefined, IsString, IsUUID, Length } from "class-validator";
import { v4 as uuid } from "uuid";

import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn } from "../orm";

@CDEntity("languages")
export class Language extends CDBaseEntity {
    @CDObjectIdColumn()
    @IsUUID("4")
    @Transform((value) => (value == undefined ? undefined : value.toString()))
    @Expose()
    public _id: string = uuid();

    @CDColumn()
    @Length(1, 16)
    @IsString()
    @IsDefined()
    @Expose()
    public isoCode: string;

    @CDColumn()
    @Length(1, 64)
    @IsString()
    @IsDefined()
    @Expose()
    public localName: string;

    @CDColumn()
    @Length(1, 64)
    @IsString()
    @IsDefined()
    @Expose()
    public englishName: string;

    @CDColumn()
    @IsBoolean()
    @IsDefined()
    @Expose()
    public isEnabled: boolean = false;
}
